import * as React from 'react';
import Div from "@jumbo/shared/Div";
import ContentWrapper from 'app/components/ContentWrapper/ContentWrapper';
import { Grid, Typography } from "@mui/material";
import MobileFooter from 'app/components/MobileFooter/MobileFooter';
import MobileHeader from 'app/components/MobileHeader/MobileHeader';
import MobileButton from 'app/components/MobileButton/MobileButton';
import { useLocation, useNavigate } from "react-router-dom";
import { setupTncParams } from 'app/services/setupWebview';
import parse from 'html-react-parser';
import Swal from 'sweetalert2';
import { AGENT, AUTH, COMMON } from 'app/utils/constants/endPoint';
import { requestApi } from 'app/utils/RestApi';
import urlConfig from 'app/config/urlConfig';
import { isMobile } from 'react-device-detect';
import { useProgram } from 'app/hooks/useProgram';
import TncViewer from 'app/components/TncViewer';

const WebViewTncReff = () => {
	const navigate = useNavigate();
	const program = useProgram();

	React.useEffect(() => {
		// if (!isMobile) {
		// 	Swal.fire({
		// 		icon: 'warning',
		// 		title: 'Forbidden!',
		// 		text: 'Halaman ini tidak dapat diakses melalui browser',
		// 		allowOutsideClick: false,
		// 		showConfirmButton: false
		// 	});
		// }
	}, []);
	const [params, setParams] = React.useState(null);
	const [dataView, setDataView] = React.useState({
		tnc: {},
		agent: {},
		hasAgreeTNC: false
	});

	const location = useLocation();

	React.useEffect(() => {
		if (!params) {
			setupTncParams(location.search, setParams, false, errorCallback)
		}
	}, [params, location])

	React.useEffect(() => {
		if (params) {
			(async () => {
				await requestApi(COMMON.TNC_AGENT, {
					subfolder: '/' + params.agentCode
				}).then(({ data }) => {
					if (data?.status === 'success') {
						setDataView(data.data)
					}
				}).catch(err => console.log(err))
			})()
		}
	}, [params])


	const errorCallback = () => {
		localStorage.removeItem('params')
		localStorage.removeItem('restartAvailableTime')
		localStorage.removeItem('expiryTime')
		localStorage.removeItem('restartCount')
		Swal.fire({
			icon: 'warning',
			text: 'Mohon periksa kembali URL yang anda masukan',
			allowOutsideClick: false,
			showConfirmButton: false
		})
	}

	// const navigateBack = () => {
	// 	var params = localStorage.getItem('params')?localStorage.getItem('params'):""
	// 	navigate('/webViewLogin' + params)
	// }

	// const navigate = useNavigate();

	const downloadTnc = async () => {
		let apiDef = urlConfig["TNC_DOWNLOAD"];

		const agentCode = localStorage.getItem('agentCode')

		var link = apiDef.baseUrl + apiDef.endpoint + "?type=0&code=" + agentCode;

		window.ReactNativeWebView.postMessage(JSON.stringify('download_' + link));
	};

	const isSubmittingRef = React.useRef(false);

	const doAgreeTNC = async () => {
		if (isSubmittingRef.current) return;
		isSubmittingRef.current = true;

		// localStorage.setItem('agentEmail', dataView.agent.email)
		const { agent } = dataView
		localStorage.setItem('params', JSON.stringify({
			nama: agent.name,
			kode: agent.agentCode,
			email: agent.email
		}))
		navigate('/webViewOtpVerification', { state: { isTncApproval: true } });
		setTimeout(() => { isSubmittingRef.current = false; }, 1000);
	}

	const navigateBack = () => {
		window.ReactNativeWebView.postMessage(JSON.stringify('exit webview'));
		localStorage.removeItem('agentCode')
		localStorage.removeItem('token')
	}

	return (
		<Div className='page-wrapper-mobile'>

			{/* 🔥 HEADER */}
			<MobileHeader
				// onClick={navigateBack}
				backOnClick={navigateBack}
				backIcon
				headerTx={"Syarat dan Ketentuan " + program + " untuk Agen"}
				headerTxSize={13}
				titleContainerStyle={{ paddingRight: 0, justifyContent: 'flex-start' }}
			/>

			{/* 🔥 CONTENT */}
			<ContentWrapper isMobile>

				{/* 🔥 typography 
				
				
				*/}
				{/*
				<Typography fontSize={16} fontWeight={600}>Terms & Conditions {program}</Typography>
				<Div sx={{ mb: 2 }}>
					<div className='dis-flex'>
						<div className='wording-snk1'><Typography fontSize={12}>Nama</Typography></div>
						<div className='wording-snk2'><Typography fontSize={12}>:</Typography></div>
						<div className='wording-snk3'><Typography fontSize={12}>{dataView?.agent?.name}</Typography></div>
					</div>
					 <div className='dis-flex'>
						<div className='wording-snk1'><Typography fontSize={12}>No. KTP</Typography></div>
						<div className='wording-snk2'><Typography fontSize={12}>:</Typography></div>
						<div className='wording-snk3'><Typography fontSize={12}>{dataView?.agent?.name}</Typography></div>
					</div> 
					<div className='dis-flex'>
						<div className='wording-snk1'><Typography fontSize={12}>No. AGEN</Typography></div>
						<div className='wording-snk2'><Typography fontSize={12}>:</Typography></div>
						<div className='wording-snk3'><Typography fontSize={12}>{dataView?.agent?.agentCode}</Typography></div>
					</div>
				</Div>
					*/}
				{
					dataView?.tnc?.content != null &&
					<TncViewer content={dataView?.tnc?.content} date={dataView?.hasAgreeTnc ? dataView?.agent?.agreedDate : ""} batchNo={dataView?.batchNo} />
					// parse(dataView?.tnc?.content)
				}
				{/* <ol>
							<li><Typography fontSize={14}>Lorem ipsum dolor sit amet, consectetur adipiscing elit. In eu tempus elit, et consequat nisl. Quisque gravida semper rhoncus.</Typography></li>
							<li><Typography fontSize={14}>Lorem ipsum dolor sit amet, consectetur adipiscing elit. In eu tempus elit, et consequat nisl. Quisque gravida semper rhoncus.</Typography></li>
							<li><Typography fontSize={14}>Lorem ipsum dolor sit amet, consectetur adipiscing elit. In eu tempus elit, et consequat nisl. Quisque gravida semper rhoncus.</Typography></li>
							<li><Typography fontSize={14}>Lorem ipsum dolor sit amet, consectetur adipiscing elit. In eu tempus elit, et consequat nisl. Quisque gravida semper rhoncus.</Typography></li>
							<li><Typography fontSize={14}>Lorem ipsum dolor sit amet, consectetur adipiscing elit. In eu tempus elit, et consequat nisl. Quisque gravida semper rhoncus.</Typography></li>
						</ol> */}


			</ContentWrapper>

			{/* 🔥 FOOTER */}
			<MobileFooter>
				{
					dataView?.hasAgreeTnc ?
						<MobileButton
							btnText={"Unduh T&C"}
							onClick={downloadTnc}
						/>
						:
						(
							<Grid container spacing={2}>
								<Grid item xs={6}>
									<MobileButton
										isGrey={true}
										btnText={"Tidak Setuju"}
										onClick={navigateBack}
									/>
								</Grid>
								<Grid item xs={6}>
									<MobileButton
										btnText={"Setuju"}
										onClick={doAgreeTNC}
									/>
								</Grid>
							</Grid>
						)
				}
			</MobileFooter>
		</Div>

	);
};

export default WebViewTncReff;